// Only explicitly public documents may load visitor analytics. Event articles,
// appointment/password/account pages and unknown paths are excluded.
const PUBLIC_TRACKING_PATHS = new Set([
  "/", "/about", "/contact", "/imprint", "/privacy", "/meetings",
  "/new-diplomats", "/sectors", "/policies", "/initiatives",
]);

export function publicTrackingDocument(pathname: string): boolean {
  return PUBLIC_TRACKING_PATHS.has(pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname);
}

export function trackingDocumentReloadRequired(documentPathname: string, destinationPathname: string): boolean {
  return publicTrackingDocument(documentPathname) !== publicTrackingDocument(destinationPathname);
}

// Independently guard the original URL before any vendor code is downloaded.
// No query string or fragment is ever passed to a tracking provider.
export const PUBLIC_TRACKING_BOOTSTRAP = `(function(w,d){if(w.__fcTrackingDocumentInitialized)return;w.__fcTrackingDocumentInitialized=true;if(!${JSON.stringify([...PUBLIC_TRACKING_PATHS])}.includes(w.location.pathname.replace(/\\/+$/, '')||'/')||w.location.search||w.location.hash)return;var j=d.createElement('script');j.async=true;j.referrerPolicy='no-referrer';j.src='https://slsnlytcs.com/stm.js?id=S9j4Q9L1D7u6';d.head.appendChild(j);})(window,document)`;